<template>
  <div v-bind:class="bodyClassObject">
    <div class="wrapper">
      <HeaderComponent></HeaderComponent>
      <MenuComponent active="orders"></MenuComponent>
      <OrdersContentComponent v-bind:countries="countries" v-bind:camps="camps"></OrdersContentComponent>
      <FooterComponent></FooterComponent>
      <AlertComponent></AlertComponent>
    </div>
  </div>
</template>

<script>
import MenuComponent from './Menu';
import OrdersContentComponent from './OrdersContent';
import HeaderComponent from './Header';
import FooterComponent from './Footer';
import AlertComponent from './Alert';
import axios from 'axios';

export default {
  name: 'Camps',
  data () {
    return {
      camps: [],
      countries: []
    };
  },
  created () {
    axios.defaults.headers.common['Authorization'] =
      // eslint-disable-next-line no-undef
        $cookies.get('jwt');
  },
  components: {
    OrdersContentComponent,
    MenuComponent,
    HeaderComponent,
    FooterComponent,
    AlertComponent
  },
  computed: {
    bodyClassObject: function () {
      return {
        'skin-blue': window.application === 'cabinet',
        'skin-green': window.application !== 'cabinet'
      };
    }
  }
};
</script>

<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .home__wrapper {
  }
</style>
